<template>
	<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
		<div class="row">
			<div class="col-md-3">
				<b>Técnico</b>
				<a-select style="width: 100%" v-model="payload.id" @change="generateReport">
					<a-select-option value="" selected>Todos</a-select-option>
					<a-select-option v-for="(element, key) in theMechanicalTechnicians" :key="key" :value="element.tallerID"> {{ element.shortName }} </a-select-option>
				</a-select>
			</div>
			<div class="col-md-3">
				<b>Rango de fecha</b>
				<a-range-picker style="width: 100%" v-model="payload.date" :format="dateFormat" @change="generateReport" />
			</div>
		</div>
		<hr />
		<div class="row" v-for="(element, index) in reportData" :key="index">
			<div class="col-md-12">
				<!-- <div>({{ element.id }}) - {{ getNombreTecnico(element.id) }}</div> -->
				<div>{{ getNombreTecnico(element.id) }}</div>
				<div><b>TOTAL:</b> {{ numeral(element.total).format('$0,0') }}</div>
				<!-- <div><b>SUELDO BASE:</b> ---</div>
				<div><b>COMISIÓN:</b> ---</div> -->
				<!-- <div><b>TOTAL:</b> {{ numeral(element.total).format('$0,0') }}</div> -->
				<div>
					<a-collapse>
						<a-collapse-panel :header="`${getCantidadServicios(index)} Servicios`">
							<div v-for="(servicio, indexServicio) in element.servicios" :key="indexServicio">
								<div>
									<b>ODS:</b><a :href="`https://taller.rls.com.mx/admin/servicios/${servicio.id_servicio}`" target="_blank">{{ servicio.id_servicio }}</a> ---
									{{ utilities.replaceText(servicio.descripcion.toLowerCase(), 'mano de obra - ', '') }} || {{ numeral(servicio.total).format('$0,0') }}
								</div>
							</div>
						</a-collapse-panel>
					</a-collapse>
				</div>
			</div>
			<div class="col-md-12">
				<hr />
			</div>
		</div>
	</a-spin>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
const dateFormat = 'DD-MM-YYYY'
import utilities from '@/services/utilities'
import { mechanicalTechnicians } from '@/constants'

export default {
	name: 'posReportsComponent',
	computed: {
		spinnerLoader() {
			return this.$store.state.pos.spinnerLoader
		},
		spinnerLoaderLabel() {
			return this.$store.state.pos.spinnerLoaderLabel
		},
		theMechanicalTechnicians() {
			// console.log(mechanicalTechnicians.length)
			let response = []
			let localMT = _.cloneDeep(mechanicalTechnicians)

			if (mechanicalTechnicians.length) {
				response = localMT.sort((a, b) => {
					return a.order - b.order
				})
			}

			return response
		},
	},
	data() {
		return {
			numeral,
			utilities,
			dateFormat,
			payload: {
				id: '',
				date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
			},
			reportData: [],
		}
	},
	mounted() {
		this.generateReport()
	},
	methods: {
		generateReport() {
			//
			this.reportData = []
			let thePayload = {
				id_administrador: utilities.objectValidate(this.payload, 'id', ''),
				startDate: this.payload.date[0],
				endDate: this.payload.date[1],
			}
			this.$store.dispatch('pos/GET_PRODUCTIVITY_REPORT', thePayload).then(async (response) => {
				// console.log('GET_PRODUCTIVITY_REPORT--->', response)
				this.reportData = utilities.objectValidate(response, 'data', [])
			})
		},
		getNombreTecnico(id) {
			return mechanicalTechnicians.find((e) => e.tallerID == id)?.name || '---'
		},
		getCantidadServicios(index) {
			let unique = []
			if (this.reportData.length) {
				unique = [...new Map(this.reportData[index].servicios.map((s) => [s.id_servicio, s])).values()]
			}
			return unique.length
		},
	},
}
</script>